if (!customElements.get("kit-variant-metafield-select")) {
  customElements.define(
    "kit-variant-metafield-select",
    class KitVariantMetafields extends HTMLElement {
      constructor() {
        super();
        this.metafieldOptions = ["mortar_collar", "storm_collar", "top_clamp", "adapter", "tee_end_cap", "tee_snout", "tee_body", "top_plate", "lid_cap"];

        this.customProperties = {};
        this.kitData = null;
        this.init();
      }

      init() {
        this.updateProperties();
        this.attachEventListeners();
      }

      // Retrieve variant and customer IDs
      get variantNetsuiteId() {
        return document.getElementById("kit-variant-netsuite-id")?.value || null;
      }

      get customerId() {
        return document.getElementById("kit-product")?.dataset?.customerid || null;
      }

      // Update metafield properties dynamically
      updateProperties() {
        this.defaultProperties = this.metafieldOptions.reduce((props, id) => {
          const element = document.getElementById(id);
          if (element?.value.trim()) {
            props[id] = element.value.trim();
          }
          return props;
        }, {});

        this.toggleButtons();
      }

      // Attach event listeners
      attachEventListeners() {
        this.attachFieldListeners();
        this.attachCalculatePriceListener();
        this.attachAddToCartListener();
      }

      attachFieldListeners() {
        this.metafieldOptions.forEach((key) => {
          const selectElement = document.getElementById(key);
          if (selectElement) {
            selectElement.addEventListener("change", () => {
              this.updateProperties();
            });
          }
        });
      }

      attachCalculatePriceListener() {
        const calculatePriceBtn = document.querySelector(".calculate__price");
        if (calculatePriceBtn) {
          calculatePriceBtn.addEventListener("click", async (e) => {
            e.preventDefault();
            if (!this.isCustomerLoggedIn()) return;

            this.toggleLoading(true, calculatePriceBtn);

            try {
              await this.fetchPrice();
            } catch (error) {
              console.error("Error fetching price:", error);
              this.showError(`Error al calcular precio: ${error.message}`);
            } finally {
              this.toggleLoading(false, calculatePriceBtn);
            }
          });
        }
      }

      attachAddToCartListener() {
        const addToCartButton = document.getElementById("custom_add-btn");
        if (addToCartButton) {
          addToCartButton.addEventListener("click", async (e) => {
            e.preventDefault();

            const variantId = addToCartButton.dataset.variant;
            this.customProperties = { ...this.defaultProperties, base_price: document.querySelector("#price__property")?.value };

            this.toggleLoading(true, addToCartButton);

            try {
              const cart = await this.fetchCart();
              const data = this.buildCartData(variantId, cart);

              await this.addToCart(data);
            } catch (error) {
              console.error("Error adding to cart:", error);
              this.showError(`Error al agregar al carrito: ${error.message}`);
            } finally {
              this.toggleLoading(false, addToCartButton);
            }
          });
        }
      }

      async fetchCart() {
        try {
          const response = await fetch("/cart.js");
          return await response.json();
        } catch (error) {
          console.error("Error fetching cart:", error);
          throw new Error("Could not fetch cart data");
        }
      }

      buildCartData(variantId, cart) {
        const quantityValue = parseInt(document.querySelector(".quantity__input")?.value, 10) || 1;
        const variantIdInt = parseInt(variantId);

        const matchingVariant = cart.items.find((item) => item.variant_id === variantIdInt);

        if (matchingVariant) {
          const propertiesMatch = this.metafieldOptions.every((prop) => {
            return (matchingVariant.properties[prop] || "") === (this.customProperties[prop] || "");
          });

          if (!propertiesMatch) {
            this.customProperties.unique_id = Date.now().toString();
          }
        }

        return {
          id: variantIdInt,
          quantity: quantityValue,
          properties: {
            ...this.customProperties,
            _kit_data: typeof this.kitData === 'object' ? JSON.stringify(this.kitData) : ''
          }
        };
      }

      async addToCart(data) {
        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
          });

          if (!response.ok) {
            throw new Error(await response.text());
          }

          console.log("Item added to cart:", await response.json());
          window.location.href = "/cart";
        } catch (error) {
          console.error("Error adding to cart:", error);
          this.showError(`Failed to add item to cart: ${error.message}`);
        }
      }

      // NUEVOS MÉTODOS DE VALIDACIÓN PARA BOOMI
      validateDataForBoomi() {
        const requiredFields = {
          variantNetsuiteId: this.variantNetsuiteId,
          customerId: this.customerId
        };
        
        const missingFields = Object.entries(requiredFields)
          .filter(([key, value]) => !value || value === 'null' || value === 'undefined')
          .map(([key]) => key);
          
        if (missingFields.length > 0) {
          throw new Error(`Campos requeridos faltantes para Boomi: ${missingFields.join(', ')}`);
        }
        
        // Validar que el NetSuite ID sea válido (no vacío y numérico)
        if (isNaN(this.variantNetsuiteId) || this.variantNetsuiteId <= 0) {
          throw new Error("NetSuite Variant ID debe ser un número válido");
        }
        
        return true;
      }

      buildBoomiPayload() {
        // Estructura consistente y validada para Boomi
        const payload = {
          // IDs principales - campos obligatorios
          item: this.variantNetsuiteId,
          customer: this.customerId,
          
          // Timestamp para tracking y debugging
          request_timestamp: new Date().toISOString(),
          
          // Metafields del producto
          ...this.defaultProperties
        };

        // Procesar kit_data de forma segura
        const kitDataInput = document.getElementById('kit-data-json');
        if (kitDataInput && kitDataInput.value) {
          try {
            let kitData = this.parseKitData(kitDataInput.value);
            // Solo agregar kit_data si tiene contenido válido
            if (kitData && Object.keys(kitData).length > 0) {
              Object.assign(payload, kitData);
              console.log("Kit data agregado al payload:", kitData);
            }
          } catch (e) {
            console.warn('Error procesando kit_data, continuando sin él:', e);
            // No fallar por kit_data, solo logear el warning
          }
        }

        console.log("Payload final para Boomi:", payload);
        return payload;
      }

      parseKitData(rawData) {
        let kitData = {};
        try {
          let parsedData = rawData;
          
          // Manejar múltiples niveles de stringify
          while (typeof parsedData === 'string') {
            parsedData = JSON.parse(parsedData);
          }
          
          // Procesar arrays y extraer primer valor válido
          kitData = Object.fromEntries(
            Object.entries(parsedData).map(([key, val]) => {
              if (Array.isArray(val)) {
                const firstValid = val.find(v => v !== null && v !== undefined && v !== '');
                return [key, firstValid || ''];
              }
              return [key, val || ''];
            })
          );
          
        } catch (e) {
          console.error('Error parsing kit_data:', e);
          throw new Error(`Invalid kit_data format: ${e.message}`);
        }
        
        return kitData;
      }

      async validateBoomiConnection(endpoint, token) {
        try {
          // Test básico de conectividad
          const testPayload = {
            item: this.variantNetsuiteId,
            customer: this.customerId,
            test_connection: true,
            timestamp: new Date().toISOString()
          };
          
          const response = await axios.post(endpoint, testPayload, {
            headers: {
              Authorization: `Basic ${btoa(token)}`,
              "Content-Type": "application/json",
            },
            timeout: 10000 // 10 segundos timeout
          });
          
          if (response.status !== 200) {
            throw new Error(`Boomi connection test failed: ${response.status}`);
          }
          
          console.log("Boomi connection validated successfully");
          return true;
        } catch (error) {
          console.error("Boomi connection validation failed:", error);
          throw new Error(`Connection test failed: ${error.message}`);
        }
      }

      async fetchPrice() {
        const optionsWrapper = this.closest(".kit__options-wrapper");
        if (!optionsWrapper) {
          this.showError("Error de configuración: wrapper no encontrado");
          return;
        }

        const { token, url: endpoint } = optionsWrapper.dataset;
        
        if (!token || !endpoint) {
          this.showError("Error de configuración: token o endpoint faltante");
          return;
        }

        try {
          // VALIDACIONES PREVIAS OBLIGATORIAS
          this.validateDataForBoomi();
          
          // Opcional: Test de conectividad (comentar si causa problemas)
          // await this.validateBoomiConnection(endpoint, token);
          
          // Construir payload validado
          const payload = this.buildBoomiPayload();
          
          console.log("Enviando request a Boomi:", payload);
          
          const response = await axios.post(endpoint, payload, {
            headers: {
              Authorization: `Basic ${btoa(token)}`,
              "Content-Type": "application/json",
            },
            timeout: 15000 // 15 segundos para requests de precio
          });

          if (response.status === 200) {
            if (response.data?.price) {
              this.updatePrice(response.data.price);
              console.log("Precio actualizado exitosamente:", response.data.price);
            } else {
              console.warn("No se recibió precio en la respuesta, usando fallback");
              this.updatePrice(700.49); // Fallback price
            }
            
            // Guardar kit_data de la respuesta
            if (response.data?.kit_data) {
              this.kitData = response.data.kit_data;
              console.log("Kit data recibido:", this.kitData);
            }
            
            this.showError(false);
          } else {
            throw new Error(`Request failed with status: ${response.status}`);
          }
        } catch (error) {
          console.error("Error fetching price:", error);
          
          // Mostrar mensaje de error más específico
          let errorMessage = "Error al obtener precio";
          if (error.message.includes("Campos requeridos faltantes")) {
            errorMessage = "Datos incompletos. Verifique la configuración del producto.";
          } else if (error.message.includes("Connection test failed")) {
            errorMessage = "Error de conexión con el servidor. Intente nuevamente.";
          } else if (error.code === 'ECONNABORTED') {
            errorMessage = "Timeout: El servidor tardó demasiado en responder.";
          } else if (error.response?.status === 401) {
            errorMessage = "Error de autenticación. Contacte al administrador.";
          } else if (error.response?.status >= 500) {
            errorMessage = "Error del servidor. Intente nuevamente en unos momentos.";
          }
          
          this.showError(errorMessage);
        }
      }

      kitData(data) {
        this.kitData = data;
      }

      updatePrice(price) {
        const formattedPrice = `${Number(price).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;

        document.querySelector("#price__property").value = Number(price).toFixed(2);
        document.querySelector(".price-item span").textContent = formattedPrice;

        document.getElementById("custom_add-btn").style.display = "flex";
        document.querySelector(".calculate__price").style.display = "none";
      }

      toggleButtons() {
        const calculatePriceBtn = document.querySelector(".calculate__price");
        const addToCartButton = document.getElementById("custom_add-btn");

        if (calculatePriceBtn) calculatePriceBtn.style.display = "flex";
        if (addToCartButton) addToCartButton.style.display = "none";
      }

      toggleLoading(isLoading, button) {
        const loader = button.querySelector(".btn-ring");
        if (loader) loader.style.display = isLoading ? "block" : "none";
        button.disabled = isLoading;
      }

      showError(message = "") {
        const fetchError = document.querySelector(".boomi__error-popup");
        if (fetchError) {
          fetchError.style.display = message ? "block" : "none";
          if (message) {
            fetchError.textContent = message;
          }
        } else {
          // Fallback if error popup doesn't exist
          if (message) {
            console.error("Error popup not found. Error message:", message);
            alert(message); // Temporary - replace with your notification system
          }
        }
      }

      isCustomerLoggedIn() {
        if (!this.customerId) {
          const loginPopup = document.querySelector(".customer_login_popup");
          if (loginPopup) {
            loginPopup.style.display = "block";
          }
          console.warn("Customer not logged in. Redirecting...");
          setTimeout(() => {
            window.location.href = "/account/login";
          }, 2000);
          return false;
        }
        return true;
      }
    }
  );
}